import { PartnerPracticeType } from '@/shared/types/partner-practice-type';
import { User } from '@/shared/user';
import { State } from '@/stores/types/state';
import { GetterTree } from 'vuex';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public additionalDocumentTypes = (state: State) => {
        return state.additionalDocumentTypes;
    }

    public activeAdditionalDocumentTypes = (state: State) => {
        return state.additionalDocumentTypes.filter((t) => !t.isArchived);
    }

    public appointmentCancellationTypes = (state: State) => {
        return state.appointmentCancellationTypes;
    }

    public activeAppointmentCancellationTypes = (state: State) => {
        return state.appointmentCancellationTypes.filter((t) => !t.isArchived);
    }

    public appointmentExecutorTypes = (state: State) => {
        return state.appointmentExecutorTypes;
    }

    public activeAppointmentExecutorTypes = (state: State) => {
        return state.appointmentExecutorTypes.filter((t) => !t.isArchived);
    }

    public appointmentReasonTypes = (state: State) => {
        return state.appointmentReasonTypes;
    }

    public activeAppointmentReasonTypes = (state: State) => {
        return state.appointmentReasonTypes.filter((t) => !t.isArchived);
    }

    public appointmentNoInstructionTypes = (state: State) => {
        return state.appointmentNoInstructionTypes;
    }

    public activeAppointmentNoInstructionTypes = (state: State) => {
        return state.appointmentNoInstructionTypes.filter((t) => !t.isArchived);
    }

    public appointmentOutcomeTypes = (state: State) => {
        return state.appointmentOutcomeTypes;
    }

    public activeAppointmentOutcomeTypes = (state: State) => {
        return state.appointmentOutcomeTypes.filter((t) => !t.isArchived);
    }

    public appointmentPaymentStatusTypes = (state: State) => {
        return state.appointmentPaymentStatusTypes;
    }

    public activeAppointmentPaymentStatusTypes = (state: State) => {
        return state.appointmentPaymentStatusTypes.filter((t) => !t.isArchived);
    }

    public appointmentProductTypes = (state: State) => {
        return state.appointmentProductTypes;
    }

    public activeAppointmentProductTypes = (state: State) => {
        return state.appointmentProductTypes.filter((t) => !t.isArchived);
    }

    public appointmentProductTypeDescription = (state: State) => (id: string | null): string => {
        if (id == null) { return ''; }

        const type = state.appointmentProductTypes.find((t) => t.id === id);
        return type == null ? '' : type.value;
    }

    public appointmentTypes = (state: State) => {
        return state.appointmentTypes;
    }

    public activeAppointmentTypes = (state: State) => {
        return state.appointmentTypes.filter((t) => !t.isArchived);
    }

    public clientOriginalSourceTypes = (state: State) => {
        return state.clientOriginalSourceTypes;
    }

    public clientOriginalSourceTypeDescription = (state: State) => (id: string | null): string => {
        const clientOriginalSourceType = state.clientOriginalSourceTypes.find((type) => type.id! === id);
        return clientOriginalSourceType == null ? '' : clientOriginalSourceType.value!;
    }

    public activeClientOriginalSourceTypes = (state: State) => {
        return state.clientOriginalSourceTypes.filter((t) => !t.isArchived);
    }

    public clientRelationshipTypes = (state: State) => {
        return state.clientRelationshipTypes;
    }

    public activeClientRelationshipTypes = (state: State) => {
        return state.clientRelationshipTypes.filter((t) => !t.isArchived);
    }

    public clientStatusTypes = (state: State) => {
        return state.clientStatusTypes;
    }

    public activeClientStatusTypes = (state: State) => {
        return state.clientStatusTypes.filter((t) => !t.isArchived);
    }

    public clientTitleTypes = (state: State) => {
        return state.clientTitleTypes;
    }

    public activeClientTitleTypes = (state: State) => {
        return state.clientTitleTypes.filter((t) => !t.isArchived);
    }

    public interactionLetterTypes = (state: State) => {
        return state.interactionLetterTypes;
    }

    public activeInteractionLetterTypes = (state: State) => {
        return state.interactionLetterTypes.filter((t) => !t.isArchived);
    }

    public interactionOutcomeTypes = (state: State) => {
        return state.interactionOutcomeTypes;
    }

    public activeInteractionOutcomeTypes = (state: State) => {
        return state.interactionOutcomeTypes.filter((t) => !t.isArchived);
    }

    public interactionTypes = (state: State) => {
        return state.interactionTypes;
    }

    public activeInteractionTypes = (state: State) => {
        return state.interactionTypes.filter((t) => !t.isArchived);
    }

    public activePartnerPracticeTypes = (state: State) => {
        return state.partnerPracticeTypes.filter((t) => !t.isArchived);
    }

    public activePartnerPracticeTypesForCurrentUser = (state: State, getters: Getters, rootState: any, rootGetters: any) => {

        const currentUser: User = rootGetters['user/user'];

        if (currentUser == null) {
            return new Array<PartnerPracticeType>();
        }

        const activePartnerPracticeTypes: any = getters.activePartnerPracticeTypes;

        return currentUser.partnerPracticeId == null ? activePartnerPracticeTypes : activePartnerPracticeTypes.filter((t: PartnerPracticeType) => t.id === currentUser.partnerPracticeId);
    }

    public powerOfAttorneyTypes = (state: State) => {
        return state.powerOfAttorneyTypes;
    }

    public activePowerOfAttorneyTypes = (state: State) => {
        return state.powerOfAttorneyTypes.filter((t) => !t.isArchived);
    }

    public willTypes = (state: State) => {
        return state.willTypes;
    }

    public activeWillTypes = (state: State) => {
        return state.willTypes.filter((t) => !t.isArchived);
    }
}
